

export const authChecker = () => {
  let isAuthenticated = false;

  if (localStorage.getItem("account")) {
    isAuthenticated = true;
  }

  return isAuthenticated;
};
